import DOMPurify from 'dompurify';
import { marked } from 'marked';

marked.setOptions({
  mangle: false,
  headerIds: false,
  breaks: true
});

export const renderMarkdown = (text = '') => {
  const raw = marked.parse(text);
  const sanitized = DOMPurify.sanitize(raw, { ADD_ATTR: ['target', 'rel'] });

  if (typeof window === 'undefined' || typeof DOMParser === 'undefined') {
    return sanitized;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(sanitized, 'text/html');
  const images = doc.querySelectorAll('img');

  images.forEach((img) => {
    const parent = img.parentElement;
    if (parent && parent.tagName === 'A') {
      parent.setAttribute('target', '_blank');
      parent.setAttribute('rel', 'noopener noreferrer');
      return;
    }

    const link = doc.createElement('a');
    link.setAttribute('href', img.getAttribute('src') || '#');
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
    img.replaceWith(link);
    link.appendChild(img);
  });

  return DOMPurify.sanitize(doc.body.innerHTML, { ADD_ATTR: ['target', 'rel'] });
};
